import React from 'react';
import { Link } from 'react-router-dom';
import './Home.scss';
import image from '../../assets/neuropsychologie.png';

/**
 * Page d'accueil du site Marie Guennec Neuropsychologue
 */
const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container hero-container">
          <div className="hero-content">
            <h1 className="hero-title">Marie Guennec</h1>
            <h2 className="hero-subtitle">Psychologue – Neuropsychologue à Bouaye</h2>
            
            <div className="hero-welcome-card">
              <h3>BIENVENUE</h3>
              <p>
                Je vous accueille au sein de mon cabinet pour la réalisation de <strong>bilans neuropsychologiques</strong> destinés aux adolescents (à partir de 16 ans), aux adultes et aux personnes âgées. Je propose également des <strong>accompagnements cognitifs adaptés</strong> à vos besoins.
              </p>
              <p>
                L'évaluation de l'efficience intellectuelle <strong>(QI)</strong> est proposée à partir de 14 ans.
              </p>
              <p>
                En tant que psychologue, je propose également des séances de <strong>psychothérapie</strong> aux adolescents à partir de 16 ans, aux adultes et aux personnes âgées, afin de vous accompagner face aux difficultés que vous pouvez rencontrer.
              </p>
              <p className="hero-contact-invite">
                N’hésitez pas à me contacter pour échanger sur votre situation.
              </p>
              <div className="hero-actions">
                <Link to="/bilan-neuropsychologique" className="btn btn-primary">
                  Découvrir les bilans
                </Link>
                <a href="https://www.ibookthedate.fr/psychologue/44830-bouaye/marie-guennec" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                  Prendre rendez-vous
                </a>
              </div>
            </div>
          </div>

          {/* Image Placeholder adaptable */}
          <div className="hero-image-wrapper">
            <img 
              src={image} 
              alt="Cabinet de consultation Marie Guennec" 
              className="hero-img"
            />
          </div>
        </div>
      </section>

      {/* Section Pourquoi Consulter */}
      <section className="why-consult-section">
        <div className="container">
          <h2 className="section-title">Pourquoi consulter un neuropsychologue ?</h2>
          <p className="section-intro">
            Une consultation en neuropsychologie peut être indiquée lorsque vous rencontrez :
          </p>

          <div className="reasons-grid">
            <div className="reason-card">
              <div className="reason-icon">🧠</div>
              <p>Des difficultés de <strong>mémoire, d'attention</strong> ou de planification</p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">🎓</div>
              <p>Des <strong>difficultés</strong> dans la vie quotidienne, professionnelle ou scolaire</p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">🔍</div>
              <p>Des questionnements concernant un trouble neurodéveloppemental (par exemple un <strong>TDA/H</strong>) ou autour du <strong>haut potentiel</strong></p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">🌿</div>
              <p>Des difficultés cognitives en lien avec une <strong>maladie neurologique</strong>, un traumatisme crânien ou l'avancée en âge</p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">💡</div>
              <p>Des inquiétudes concernant des <strong>changements cognitifs</strong> récents</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">🌪️</div>
              <p>Difficultés dans la <strong>gestion des émotions</strong>, de l'hypersensibilité</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;